/* khs-atb-feedback.js ------------------------------------------------
   Tap-Feedback für die Add-to-Bag-Buttons. Drei Zustände:

     Ruhe        schwarz
     Unterwegs   #002BFF + Spinner, solange /cart/add läuft
     Bestätigung Stahlgrau + "IN BAG ✓", dann zurück zu Ruhe

   Blau ist die einzige Farbe im Shop und markiert genau die Sekunde,
   in der man nicht weiss, ob der Klick angekommen ist.

   v141: erfasst jetzt BEIDE Buttons. Vorher hing das hier nur an
   .product-form__submit.button — der Inline-Button auf der
   Produktseite, also der zuerst sichtbare, hatte gar kein Feedback.

   Durchgehend abgesichert: fehlt etwas, passiert einfach nichts.
------------------------------------------------------------------- */
(function () {
  'use strict';

  var DONE_LABEL = 'IN BAG \u2713';
  var DONE_MS = 1300;
  var MIN_FLIGHT_MS = 420;   /* sonst blitzt das Blau bei schneller
                                Verbindung nur 80ms auf und zuckt */
  var MAX_FLIGHT_MS = 8000;  /* Notbremse, falls kein Ergebnis kommt */

  var SEL = '.product-form__submit.button, .khs-inline-atb';

  function allButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL));
  }

  function decorate(btn) {
    if (btn.__khsFx) return;
    btn.__khsFx = true;

    // "IN BAG ✓" einmal anlegen
    var done = document.createElement('span');
    done.className = 'khs-added-label';
    done.textContent = DONE_LABEL;
    done.setAttribute('aria-hidden', 'true');
    btn.appendChild(done);

    // Spinner für den Ladezustand einmal anlegen
    var spin = document.createElement('span');
    spin.className = 'khs-spin';
    spin.setAttribute('aria-hidden', 'true');
    spin.appendChild(document.createElement('i'));
    btn.appendChild(spin);

    // Ripple am Berührungspunkt
    btn.addEventListener('pointerdown', function (e) {
      try {
        var r = btn.getBoundingClientRect();
        var s = document.createElement('span');
        s.className = 'khs-ripple';
        s.style.left = (e.clientX - r.left) + 'px';
        s.style.top = (e.clientY - r.top) + 'px';
        btn.appendChild(s);
        setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 560);
      } catch (err) { /* egal */ }
    }, { passive: true });

    // Klick startet den Ladezustand. Beendet wird er vom Cart-Event,
    // nicht von einem Timer — die Farbe steht für "läuft noch".
    btn.addEventListener('click', function () { startFlight(btn); });
  }

  function startFlight(btn) {
    if (btn.__khsBusy) return;
    btn.__khsBusy = true;
    btn.__khsStart = Date.now();
    btn.classList.add('khs-loading');
    btn.setAttribute('aria-busy', 'true');

    clearTimeout(btn.__khsBail);
    btn.__khsBail = setTimeout(function () { endFlight(btn, false); }, MAX_FLIGHT_MS);
  }

  function endFlight(btn, ok) {
    if (!btn.__khsBusy) return;
    var elapsed = Date.now() - (btn.__khsStart || 0);
    var wait = Math.max(0, MIN_FLIGHT_MS - elapsed);

    setTimeout(function () {
      clearTimeout(btn.__khsBail);
      btn.classList.remove('khs-loading');
      btn.removeAttribute('aria-busy');

      if (!ok) { btn.__khsBusy = false; return; }

      btn.classList.add('khs-added');
      setTimeout(function () {
        btn.classList.remove('khs-added');
        btn.__khsBusy = false;
      }, DONE_MS);
    }, wait);
  }

  function finishAll(ok) {
    allButtons().forEach(function (b) { endFlight(b, ok); });
  }

  function init() {
    allButtons().forEach(decorate);

    // Der Theme-Stack meldet den fertigen Warenkorb über sein Pub/Sub.
    if (window.PUB_SUB_EVENTS && window.subscribe) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { finishAll(true); });
      } catch (e) { /* Fetch-Hook unten fängt es auf */ }
    }

    // Fallback: direkt am /cart/add-Fetch hängen. Liefert ausserdem den
    // Fehlerfall — dann geht das Blau aus, ohne Bestätigung zu zeigen.
    if (window.fetch && !window.__khsFetchHooked) {
      window.__khsFetchHooked = true;
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = (args[0] && args[0].url) || args[0] || '';
        var p = origFetch.apply(this, args);
        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
          p.then(function (res) { finishAll(!!(res && res.ok)); })
           .catch(function () { finishAll(false); });
        }
        return p;
      };
    }

    // Variantenwechsel ersetzt den Button im DOM — neu verkabeln.
    if (window.MutationObserver) {
      var host = document.querySelector('.product-form') || document.body;
      new MutationObserver(function () {
        allButtons().forEach(decorate);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
